<script setup lang="ts">
// pass slots through from parent to child components https://gist.github.com/loilo/73c55ed04917ecf5d682ec70a2a1b8e2
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
const slots = defineSlots<{}>();
</script>

<template>
  <v-tooltip
    :class="$style.kTooltip"
    data-testid="kTooltip"
    content-class="g-tooltip"
    :open-delay="500"
    :close-delay="250"
    interactive
  >
    <template v-for="(_, name) in slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData as object" />
    </template>
  </v-tooltip>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

html .kTooltip {
  :global {
    .g-tooltip {
      font-size: 12px;
      letter-spacing: 0;
      color: colors.$color-white;
      background-color: colors.$color-gray-600;
      border-radius: 4px;
      padding: 6px 8px;
    }
  }
}
</style>
